import { ClientOnly } from "../client-only";
import { APP_NAME, WEB_DOMAIN } from "@ascra/utils";
import { useTranslations } from "next-intl";
import type { PropsWithChildren, ReactNode } from "react";
import { Suspense } from "react";

const asReactNode = (value: unknown): ReactNode => value as ReactNode;

export const AuthLayout = ({
  children,
  showTerms = false,
}: PropsWithChildren<{ showTerms?: boolean }>) => {
  const t = useTranslations();

  return (
    <div className="flex min-h-screen w-full flex-col items-center justify-between">
      {/* Empty div to help center main content */}
      <div className="grow basis-0">
        <div className="h-24" />
      </div>

      <ClientOnly className="relative flex w-full flex-col items-center justify-center px-4">
        <Suspense>{children}</Suspense>
      </ClientOnly>

      <div className="flex grow basis-0 flex-col justify-end">
        {showTerms && (
          <p
            data-testid="terms"
            className="px-20 py-8 text-center font-medium text-muted-foreground text-xs md:px-0"
          >
            {asReactNode(
              t.rich(
                "auth.terms",
                {
                  appName: APP_NAME,
                  terms: (chunks) => (
                    <a
                      href={`${WEB_DOMAIN}/legal/terms`}
                      className="font-semibold text-foreground/80 transition-colors hover:text-foreground"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {asReactNode(chunks)}
                    </a>
                  ),
                  privacy: (chunks) => (
                    <a
                      href={`${WEB_DOMAIN}/legal/privacy`}
                      className="font-semibold text-foreground/80 transition-colors hover:text-foreground"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {asReactNode(chunks)}
                    </a>
                  ),
                },
              ),
            )}
          </p>
        )}
      </div>
    </div>
  );
};